import React from 'react';
import testimonial from '../../images/pristyn-care/testimonial.png';
import WhyVisit from './whyVisit';

const TestimonialCard = (props) => (
  <div
    style={{
      display: 'inline-block',
      border: ' 1px solid #C8C8C8',
      borderRadius: '14px',
      marginTop: '20px',
      minWidth: '310px',
      marginRight: '25px',
    }}
  >
    <img
      src={testimonial}
      alt="testimonial"
      style={{
        textAlign: 'right',
        height: '20px',
        marginLeft: 'auto',
        display: 'block',
        marginTop: '20px',
        marginRight: '20px',
      }}
    />
    <div style={{ padding: '15px', borderBottom: '1px solid #C8C8C8' }}>
      <p
        style={{
          color: '#0D2059',
          fontWeight: 600,
          fontSize: '12px',
          lineHeight: '15px',
          paddingBottom: '10px',
        }}
      >
        {props.title}
      </p>
      <p
        style={{
          color: '#465C67',
          fontWeight: 500,
          fontSize: '10px',
          lineHeight: '15px',
        }}
      >
        {props.desc}
      </p>
    </div>
    <div
      style={{
        marginLeft: '20px',
        marginTop: '10px',
        marginBottom: '-10px',
      }}
    >
      <WhyVisit
        backgroundColor="white"
        icon={props.userIcon}
        title={props.name}
        desc={props.location}
        imageHeight="33px"
        imageWidth="33px"
      />
    </div>
  </div>
);

export default TestimonialCard;
